import Confirm from "./prompt";

export default Confirm;
